import React,{useContext} from 'react'
import {themeContext} from '../../Context'

import { Container, Row, Col } from 'reactstrap';
import calculateExp from '../../experienceCalculator'
import './Experience.css'
const Experience = () => {
    const theme = useContext(themeContext)
    const darkMode = theme.state.darkMode;
    
    return (
        <section className='mb-5' id="experience">
            <Container>
                <Row>
                    <Col lg="12" className="mb-5">
                        <h2> Experience ({calculateExp(new Date('7/23/2019'))}+ years)</h2>
                    </Col>
                    <Col lg='6' md='6'>
                        <ExperienceCard darkMode={darkMode} year='2019-2020' role='Software Engineer' desc='GitHub, Kibana, SonarQube, ALM Application Lifecycle Management, JIRA, HTML5, CSS3, JavaScript, OJet' />
                        <ExperienceCard darkMode={darkMode} year='2021-2022' role='Associate Consultant' desc='GitHub, Kibana, SonarQube, ALM Application Lifecycle Management, JIRA, HTML5, CSS3, JavaScript, OJet' />
                    </Col>
                    <Col lg='6' md='6'>
                        <ExperienceCard darkMode={darkMode} year='2020-2021' role='Senior Software Engineer' desc='GitHub, Kibana, SonarQube, ALM Application Lifecycle Management, JIRA, HTML5, CSS3, JavaScript, OJet' />
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
const ExperienceCard = ({ year, role, desc,darkMode }) => {
    return (
        <div className={`single_experience-container ${darkMode?'single_experience-container_dark':'single_experience-container_light'}`}>
            <div className="single_experience">
                <span> <i className="ri-briefcase-line experience_icon" style={{color:darkMode?'#7865ff':'#00509d'}}> </i> </span>
                <h6>{year}</h6>
                <h5>{role}</h5>
                <span style={{color: darkMode?'#FFFFFF':'#000000'}}>Sills used: <p>{desc}</p></span>
            </div>
        </div>
    )
}

export default Experience